import React, { useCallback, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { DropdownList } from 'react-widgets';
import ChartKit from '../../../ChartKit/ChartKit.jsx';
import ChartTypeToggle from '../../../ChartKit/ChartTypeToggle.jsx';
import { I18nContext } from 'utils/I18n/context';
const StatisticsChart = (props) => {
    const { t } = useContext(I18nContext) || {};

    const [yAxesLeft, setYAxesLeft] = useState('Visits');
    const [yAxesRight, setYAxesRight] = useState('PublisherCreditTotalAmountConfirmed');
    const [metrics, setMetrics] = useState([]);
    const [yAxesLeftLabelName, setYAxesLeftLabelName] = useState('left');
    const [yAxesRightLabelName, setYAxesRightLabelName] = useState('right');
    const [chartType, setChartType] = useState('bar');
    const [currentGroupBy, setCurrentGroupBy] = useState(props.parameters?.group_by || '');

    useEffect(() => {
        if (props.parameters?.group_by !== currentGroupBy) {
            setCurrentGroupBy(props.parameters?.group_by || '');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.parameters?.group_by]);

    useEffect(() => {
        if (metrics.length > 0) {
            const right = metrics.find(m => m.value === yAxesRight);
            const left = metrics.find(m => m.value === yAxesLeft);
            if (right) setYAxesRightLabelName(right.title);
            if (left) setYAxesLeftLabelName(left.title);
        }
    }, [metrics, yAxesLeft, yAxesRight]);

    useEffect(() => () => { props.clear && props.clear(); }, []);

    const onChangeDropdownList = useCallback((value, key) => {
        if (!value) return;
        if (key === 'yAxesRight') {
            setYAxesRight(value.value);
            setYAxesRightLabelName(value.title);
        } else if (key === 'yAxesLeft') {
            setYAxesLeft(value.value);
            setYAxesLeftLabelName(value.title);
        }
    }, []);

    const onChangeGroupBy = useCallback((item) => {
        if (!item) return;
        setCurrentGroupBy(item.value);
        props.onAction && props.onAction({ currentGroupBy: item.value });
    }, [props]);

        const onSetMetrics = useCallback((m) => {
            const list = Array.isArray(m) ? m.filter(it => it && it.title) : [];
            setMetrics(list);
        }, []);

    const onSetChartType = useCallback((type) => setChartType(type), []);

    return (
        <div className="card dashboard-chart-card">
            <div className="card-header d-flex justify-content-between align-items-center">
                <div className="d-flex gap-3 align-items-center flex-lg-nowrap flex-wrap">
                    <div className="table-filter__item">
                        <DropdownList
                            className={'rw-dropdownlist-select dimension dimension__first'}
                            valueField={'value'}
                            textField={'title'}
                            data={metrics}
                            value={metrics.find(m => m.value === yAxesLeft)}
                            disabled={[metrics.find(m => m.value === yAxesRight)]}
                            onChange={(value) => {
                                if (value) onChangeDropdownList(value, 'yAxesLeft');
                            }}
                        />
                    </div>
                    <div className="table-filter__item">
                        <DropdownList
                            className={'rw-dropdownlist-select dimension dimension__second'}
                            valueField={'value'}
                            textField={'title'}
                            data={metrics}
                            value={metrics.find(m => m.value === yAxesRight)}
                            disabled={[metrics.find(m => m.value === yAxesLeft)]}
                            onChange={(value) => {
                                if (value) onChangeDropdownList(value, 'yAxesRight');
                            }}
                        />
                    </div>
                    <div className="table-filter__item filter-by-group">
                        <DropdownList
                            className={'rw-dropdownlist-select'}
                            valueField={'value'}
                            textField={'title'}
                            data={props.groupBy || []}
                            value={(props.groupBy || []).find(g => g.value === currentGroupBy)}
                            onChange={(value) => {
                                if (value) onChangeGroupBy(value);
                            }}
                        />
                    </div>
                    <ChartTypeToggle 
                        value={chartType} 
                        onChange={onSetChartType}
                        labels={{
                            bars: t?.chart?.bars || 'Bars',
                            lines: t?.chart?.lines || 'Lines'
                        }}
                    />
                </div>
            </div>
            <div className="card-body">
                <div className="chart-container">
                    <ChartKit type={chartType} chartData={props.chartData} yAxesLeft={yAxesLeft} yAxesRight={yAxesRight} parameters={props.parameters} loading={props.loading} getMetrics={onSetMetrics} height={320} />
                </div>
            </div>
        </div>
    );
};

StatisticsChart.propTypes = {
    labels: PropTypes.array,
    parameters: PropTypes.object,
    chartData: PropTypes.any,
    groupBy: PropTypes.any,
    disabledGroupBy: PropTypes.any,
    loading: PropTypes.bool,
    clear: PropTypes.func,
    onAction: PropTypes.func,
};

StatisticsChart.defaultProps = {
    labels: [],
    parameters: {}
};

export default StatisticsChart;
